/* Project Import will be here */
import { post, IRequest, authTokenKey } from "../index";
import { IStaticContentParams } from "models/commonModels";
/* Project Import will be here */

export const getStaticContentListApi = (data: IStaticContentParams, token) => {
  let request: IRequest = null;

  if (token !== null)
    request = { subUrl: `/AppConfig/StaticContent`, data, headers: { [authTokenKey]: token } };
  else
    request = { subUrl: `/AppConfig/StaticContent`, data };

  return post(request);
}